/**
 *
 * SupportCard
 *
 * UI for handling some fun events for support cards
 */


const $         = require( 'jQuery' );

var SupportCard = function(el){
    this.$el            = $(el);
    this.$infoToggle    = this.$el.find( '.js-support-card-info-toggle' );
    this.$ctaButton     = this.$el.find( '.js-support-card-cta-button__unauthorized' );
    this.$overlayContent = this.$el.find( '.js-support-card-overlay-content' );

    this.init();
};

SupportCard.prototype.init = function(){
    var $overlayContent = this.$overlayContent;
    var closeOverlay = this.closeOverlay.bind(this);
    var event__showOverlay = this.event__showOverlay.bind(this);

    [ this.$infoToggle, this.$ctaButton ].forEach(function ($e) {
        $e.on( 'click', event__showOverlay );
    });

    $(document).on('click', function (event) {
        var isContentClicked = $(event.target).closest($overlayContent[0]).length > 0;

        if (!isContentClicked) {
            closeOverlay();
        }
    });
};

SupportCard.prototype.event__showOverlay = function (event) {
    event.preventDefault();

    this.$el.addClass('overlay-open');

    return false;
};

SupportCard.prototype.closeOverlay = function () {
    this.$el.removeClass('overlay-open');
};

$(document).ready(function(){
    $('.js-support-card').each(function(){
        new SupportCard(this);
    });
});
